import { Outlet } from "react-router-dom";

export default function RX() {
  return <Outlet />;
}
